<template>
  <div class="main">
    <!-- 中间 -->
    <div>
      <div class="page__banner app-container">
        <Roimg></Roimg>
        <div class="roll-rooms">
          <a @click="$router.push({path:'/rollDetail',query:{id:itemr.id}})" class="roll-room" v-for="(itemr,indexr) in rolldata.data" :key="indexr"
            ><div class="roll-room__header">
              <div
                class="avatar-container roll-room__avatar"
                style="width: 20%"
              >
                <div class="avatar avatar_status-official">
                  <div
                    class="avatar__picture"
                    :style="{backgroundImage:'url('+itemr.logo+')'}"
                    :class="{'avatar__pictures':itemr.title.indexOf('官方') != -1 || itemr.title.indexOf('cxskins') != -1}"
                  ></div>
                </div>
                <p class="avatar__picture_p" v-if="itemr.title.indexOf('官方') != -1 || itemr.title.indexOf('cxskins') != -1">官方</p>
              </div>
              <div class="roll-room__header__content">
                <h2 :title=itemr.title class="roll-room__title">
                  {{itemr.title}}
                </h2>
                <p :title=itemr.end_time class="roll-room__date">
                  开奖时间{{itemr.end_time}}
                </p>
              </div>
            </div>
            <div class="roll-room__awards">
              <!-- <div
                class="roll-room__award roll-room__award_sssr"
                style="
                  background-image: url('data:image/png;base64,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');
                "
              >
                <div
                  class="picture-container"
                  style="padding-top: 90%; width: 100%"
                >
                  <div
                    class="picture"
                    style="
                      background-image: url('http://api.r8skins.com/uploads/20210504/a7cc26e89f11713c7b5fa67ead6367ad.png');
                      background-size: contain;
                    "
                  ></div>
                </div>
              </div> -->
              <div v-for="(itemrs,indexrs) in itemr.data" :key="indexrs" v-if="indexrs < 3"
                class="roll-room__award roll-room__award_sssr"
                style="
                  background-image: url('data:image/png;base64,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');
                "
              >
                <div
                  class="picture-container"
                  style="padding-top: 90%; width: 100%"
                >
                  <div
                    class="picture"
                    style="
                      background-size: contain;
                    "
                    :style="{backgroundImage:'url('+itemrs.logo+')'}"
                  ></div>
                </div>
              </div>
            </div>
            <!-- 时间 -->
            <div class="roll-room__countdown" v-if="isitme">
              <span class="roll-room__countdown__label">剩余<br />时间</span>
              <div class="roll-room__countdown__content">
                <div class="roll-room__countdown__time-item">
                  <span class="roll-room__countdown__time-item__number">{{tt}}</span>
                  <span class="roll-room__countdown__time-item__label"
                    >DAY</span
                  >
                </div>
                <div class="roll-room__countdown__time-item">
                  <span class="roll-room__countdown__time-item__number">{{hh}}</span
                  ><span class="roll-room__countdown__time-item__label"
                    >HOUR</span
                  >
                </div>
                <div class="roll-room__countdown__time-item">
                  <span class="roll-room__countdown__time-item__number">{{mm}}</span
                  ><span class="roll-room__countdown__time-item__label"
                    >MINUTES</span
                  >
                </div>
              </div>
            </div>


            <div class="roll-room__countdown" v-else>
              <span class="roll-room__countdown__label" style="color:rgb(255, 152, 56);">已经结束啦!</span>
            </div>
            </a>
          <!-- 无roll房时显示 -->
          <a href="/Roll" class="roll-room roll-roomwu" v-if="isrolldata"
            ><div class="no-roll">{{rolldata != '' ? '查看更多Roll房':'暂无Roll房'}}</div>
            <!-- <div class="roll-room__countdown">
              <span class="roll-room__countdown__label">剩余<br />时间</span>
              <div class="roll-room__countdown__content">
                <div class="roll-room__countdown__time-item">
                  <span class="roll-room__countdown__time-item__number">?</span
                  ><span class="roll-room__countdown__time-item__number">?</span
                  ><span class="roll-room__countdown__time-item__label"
                    >DAY</span
                  >
                </div>
                <div class="roll-room__countdown__time-item">
                  <span class="roll-room__countdown__time-item__number">?</span
                  ><span class="roll-room__countdown__time-item__number">?</span
                  ><span class="roll-room__countdown__time-item__label"
                    >HOUR</span
                  >
                </div>
                <div class="roll-room__countdown__time-item">
                  <span class="roll-room__countdown__time-item__number">?</span
                  ><span class="roll-room__countdown__time-item__number">?</span
                  ><span class="roll-room__countdown__time-item__label"
                    >MINUTES</span
                  >
                </div>
              </div>
            </div> -->
          </a>
        </div>
      </div>

      <div class="home" style="min-height: 700px">
        <div class="ant-spin-nested-loading" style="width: 100%">
          <div class="ant-spin-container">
            <div
              class="app-container"
              style="margin: 10px auto; flex-direction: column"
              v-for="(item,index) in indexdata" :key="index"
            >
              <!-- 标题图片  -->
              <!-- <img
                :src=item.logo
                alt=""
                style="width: 240px; margin: 20px auto; mix-blend-mode: screen"
              /> -->
              <!-- 标题 -->
              <div class="titile_box">
                <span class="titile_box_lint1"></span>
                <h1 class="allbox_title">{{item.title}}</h1>
                <span class="titile_box_lint2"></span>
              </div>
              <div class="page__cases">
                <!-- <div class="case" v-for="(items,indexs) in item.list" :key="indexs">
                  <div class="case__background"></div>
                  <div class="case__pictures">
                    <div
                      class="case__case-picture"
                      data-src="http://api.r8skins.com/uploads/20210504/16642554e978623def8f88eed84d183c.png"
                      lazy="loaded"
                      style="
                        background-image: url('http://api.r8skins.com/uploads/20210504/16642554e978623def8f88eed84d183c.png');
                      "
                    ></div>
                    <div
                      class="case__award-picture"
                      data-src="http://api.r8skins.com/uploads/20210429/656a3986ffcfaff89a6559571de8e63b.png"
                      lazy="loaded"
                      :style=items.logo
                    ></div>
                  </div>
                  <h2 class="case__title">{{items.title}}</h2>
                  <div class="case__info">
                    <span class="case__info__label">OPEN</span
                    ><span
                      class="case__info__currenty-icon"
                      style="background-image: url('/img/coin.5823c98a.png')"
                    ></span
                    ><span class="case__info__price">{{items.coin}}</span>
                  </div>
                  <div class="picture-container case__light">
                    <img
                      src="https://static.v5boss.com/static/img/common/box_bg_3.gif"
                      alt=""
                      class="gif_class none active"
                      style="mix-blend-mode: screen"
                    /><img
                      src="https://static.v5boss.com/static/img/common/box_bg_4.jpg"
                      alt=""
                      class="no_gif_class none"
                      style="mix-blend-mode: screen"
                    />
                  </div>
                  <div
                    class="case__open-price"
                    style="background-image: url('/img/tips1.883ea7c6.png')"
                  >
                    <span class="case__open-price__text"
                      ><img
                        src="/img/coin.5823c98a.png"
                        alt=""
                        style="margin-right: 5px"
                      />
                      13.88
                    </span>
                  </div>
                </div> -->
                <div class="case" v-for="(items,indexs) in item.list" :key="indexs" @click="$router.push({path:'/indexList',query:{id:items.id}})">
                  <div class="case__background"></div>
                  <div class="case__pictures">
                    <div
                      class="case__case-picture"
                      lazy="loading"
                      :style="{backgroundImage:'url('+items.back_logo+')'}"
                    ></div>
                    <div
                      class="case__award-picture"
                      lazy="loading"
                      :style="{backgroundImage:'url('+items.logo+')'}"
                    ></div>
                  </div>
                  <h2 class="case__title">{{items.title}}</h2>
                  <div class="case__info">
                    <span class="case__info__label">OPEN</span
                    ><span
                      class="case__info__currenty-icon"
                      :style="{backgroundImage:'url('+jinimg+')'}"
                    ></span
                    ><span class="case__info__price">{{items.coin}}</span>
                  </div>
                  <div class="picture-container case__light">
                    <img
                      src="../assets/img/box_bg_3.gif"
                      alt=""
                      class="gif_class none active"
                      style="mix-blend-mode: screen"
                    /><img
                      src="../assets/img/box_bg_4.jpg"
                      alt=""
                      class="no_gif_class none"
                      style="mix-blend-mode: screen"
                    />
                  </div>
                  <div
                    class="case__open-price"
                    style="background-image: url('_')"
                  >
                    <span class="case__open-price__text"
                      >
                      <!-- 金币图片 -->
                      <!-- <img
                        src="/img/coin.5823c98a.png"
                        alt=""
                        style="margin-right: 5px"
                      /> -->
                      {{items.coin}}
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- <div class="raise"><img src="/img/tips22.2e21a478.png" alt="" /></div> -->
      <!---->
    </div>

    <!-- 红包 -->
    <!-- <Redenvelopes></Redenvelopes> -->

    <!-- 提示窗口 -->
    <tipsBox v-if="istipsBox" :istipsBox.sync="istipsBox" :istipsBoxdata='istipsBoxdata'></tipsBox>
  </div>
</template>

<script>
import Roimg from "../components/Rotateimg";
// import Redenvelopes from "../components/Redenvelopes";
import tipsBox from "../components/tipsBox";


export default {
  components: {
    Roimg,
    tipsBox,
    // Redenvelopes,
  },
  data() {
    return {
      //服务器时间, 在组件中重新赋值, 可接受字符串或时间戳格式的日期时间值
      currentTime: Date.parse(new Date()),
      //倒计时结束时间, 在组件中重新赋值，可接受字符串或时间戳格式的日期时间值
      startTime:'',
      startTime2:'',
      // startTime: Date('2020/05/18 12:20:30').getTime(),
      //倒计时实时结果对象, 在组件中watch进行业务处理、个性化样式
      countdownTime: {},
      //倒计时
      timeCounter: null,
      tt: "",
      hh: "",
      mm: "",
      ss: "", //倒计时
      isitme: true, //时间是否结束
      indexdata:null,//首页信息
      rolldata:'',//首页的1个roll房
      isrolldata:false,//加一个判断 防止刷新比请求的图片先出来
      istipsBox:false,//是否提示
      istipsBoxdata:false,//是否提示信息
      jinimg:require("../assets/img/goldCOINS/logo.png"),//目录图片 直接索引不到
    };
  },
  methods: {
    // 红包
    redPrize() {
      document.getElementsByClassName("ivu-modal")[0].style.display = "block";
      document.getElementById("isquan").classList.add("backghui");
    },
    //加载首页箱子
    loadindex(){
      this.$axios({
        url:"/pond/getList",
        method: "POST",
      }).then ( res => {
        this.indexdata = res.data
      })
    },
    //倒计时
    filt(val) {
      return val > 9 ? val : "0" + val;
    },
    //倒计时
    _timeCallback(offset) {
      (this.tt = this.filt(Math.floor(offset / 1000 / 60 / 60 / 24))),
        (this.hh = this.filt(Math.floor((offset / 1000 / 60 / 60) % 24))),
        (this.mm = this.filt(Math.floor((offset / 1000 / 60) % 60))),
        (this.ss = this.filt(Math.floor((offset / 1000) % 60)));
      // let data = {
      //     tt: this.filt(Math.floor(offset / 1000 / 60 / 60 / 24)),
      //     hh: this.filt(Math.floor((offset / 1000 / 60 / 60) % 24)),
      //     mm: this.filt(Math.floor((offset / 1000 / 60) % 60)),
      //     ss: this.filt(Math.floor((offset / 1000) % 60))
      // };
      // this.countdownTime = data;
    },
    //倒计时
    _down(val) {
      const interval = 1000; //每次间隔ms数
      let ms = val; // 从服务器和活动开始时间计算出的时间差，这里测试用 50000 ms
      let count = 0; //倒计时次数
      const startTime = new Date().getTime(); //此值用于矫正偏差用

      const countDownStart = (callback) => {
        count++;
        const offset = new Date().getTime() - (startTime + count * interval); // A
        let nextTime = interval - offset;
        if (nextTime < 0) {
          nextTime = 0;
        }
        ms -= interval;
        //console.log(`误差：${offset} ms`);

        //倒计时终止
        if (ms < 0) {
          this.isitme = false;
          clearTimeout(this.timeCounter);
          if (typeof this.timeover === "function") {
            this.timeover();
          }
        } else {
          callback && callback(ms);
          this.timeCounter = setTimeout(() => {
            countDownStart(callback);
          }, nextTime);
        }
      };

      if (ms >= 0) {
        this.timeCounter = setTimeout(() => {
          countDownStart(this._timeCallback);
        }, interval);
      }
    },
    //首页获取前面1个roll房
    getrolldata(){
      this.$axios({
        url:'/roll/getList',
        method:"post",
        params:{
          type:1,
          page:1,
          limit:2
        }
      }).then( res =>{
        if(res.data.status == 200){
          this.rolldata = res.data
          setTimeout( () =>{
            this.isrolldata = true
          },10)
          this.startTime = res.data.data[0].end_time
        }
      })
    },
  },
  computed: {
    _offset: function () {
      return this._end - this._now;
    },
    _end: function () {
      if (typeof this.startTime === "string") {
        return new Date(
          Date.parse(this.startTime.replace(/-/g, "/"))
        ).getTime();
      } else if (typeof this.startTime === "number") {
        return new Date(this.startTime).getTime();
      }
      return new Date(this.startTime).getTime();
    },
    _now: function () {
      if (typeof this.currentTime === "string") {
        return new Date(
          Date.parse(this.currentTime.replace(/-/g, "/"))
        ).getTime();
      } else if (typeof this.currentTime === "number") {
        return new Date(this.currentTime).getTime();
      }
      return new Date(this.currentTime).getTime();
    },
  },
  watch: {
    _offset: {
      handler: function (vel) {
        vel > 0 && this._down(vel);
      },
      immediate: true,
    },
  },
  destroyed() {
    clearTimeout(this.timeCounter);
    this.timeCounter = null;
  },
  mounted(){
    //加载首页信息
    this.loadindex()
    //判断是否结束
    var a = new Date(this.startTime).getTime()
    if(a < this.currentTime){
      this.isitme = false
    }else{
      this.isitme = true
    }
    this.getrolldata()
    //首页提示信息
    this.$axios({
      url:'get/info',
      method:'post'
    }).then ( res => {
      if(res.data.data.info){
        this.istipsBoxdata = res.data.data.info
        this.istipsBox = true
      }
    })
  },
};
</script>

<style scoped lang='less'>

.page__banner {
  height: 220px;
}
.wrapper {
  width: 610px !important;
}
.roll-rooms {
  width: 60%;
  a{
    margin-right: 10px;
  }
}
.islogin {
  display: flex;
  .islogin_wallet {
    p {
      font-weight: 100 !important;
      font-size: 13px !important;
      padding-top: 8px;
    }
  }
  .islogin_data {
    text-align: center;
    padding: 0 10px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50px;
    }
  }
  .islogin_out {
    p {
      cursor: pointer;
      font-weight: 100 !important;
      font-size: 13px !important;
      padding-top: 8px;
    }
  }
}
.nav-item {
  justify-content: center !important;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}
.page__sidebar-container {
  z-index: 200;
}
//金币后文字居中
.case__open-price__text{
  left: 38%;
}
.roll-roomwu{
  padding: 0;
  background-image: url("../assets/img/15.(2).jpg");
}
//奖品图片变小一点
.case__award-picture{
  width: 80% !important;
  left: 10% !important;
}
.avatar__pictures{
  border-radius: 50% !important;
  border: 1px #E9B10E solid !important;
}
.avatar__picture_p{
  position: absolute;
  bottom: -5px;
  left:calc(50% - 18px);
  background-color: #E9B10E;
  padding: 0 6px;
  font-size: 12px;
  border-radius: 50px;
  color: #000;
}
//箱子标题
.allbox_title{
  margin: 0 auto;
  mix-blend-mode:screen;
  text-align: center;
  font-size: 20px;
  color: rgb(195, 195, 226);
  font-weight: 600;
  margin-top: 60px;
  // letter-spacing: 10px;
  // font-family:KaiTi !important;
  position: relative;
  line-height: 1;
  display: inline-block;
  margin-bottom: 35px;
}
//下划线
.allbox_title:after {
  position: absolute;
  bottom: -60%;
  width: 60%;
  height: 4px;
  background: rgb(195, 195, 226);
  content: '';
  left: 50%;
  transform: translate(-50%,-50%);
}
.allbox_title:hover{
  -webkit-animation: neon2 1s ease-in-out infinite alternate;
  -moz-animation: neon2 1s ease-in-out infinite alternate;
  animation: neon2 1s ease-in-out infinite alternate;
}
@-webkit-keyframes neon2 {
  from {
    text-shadow: 0 0 10px #666,
               0 0 20px  #666,
               0 0 30px  #666,
               0 0 40px  #228DFF,
               0 0 70px  #228DFF,
               0 0 80px  #228DFF,
               0 0 100px #228DFF,
               0 0 150px #228DFF;
  }
  to {
    text-shadow: 0 0 5px #666,
               0 0 10px #666,
               0 0 15px #666,
               0 0 20px #228DFF,
               0 0 35px #228DFF,
               0 0 40px #228DFF,
               0 0 50px #228DFF,
               0 0 75px #228DFF;
  }
}
@-moz-keyframes neon2 {
  from {
    text-shadow: 0 0 10px #666,
               0 0 20px  #666,
               0 0 30px  #666,
               0 0 40px  #228DFF,
               0 0 70px  #228DFF,
               0 0 80px  #228DFF,
               0 0 100px #228DFF,
               0 0 150px #228DFF;
  }
  to {
    text-shadow: 0 0 5px #666,
               0 0 10px #666,
               0 0 15px #666,
               0 0 20px #228DFF,
               0 0 35px #228DFF,
               0 0 40px #228DFF,
               0 0 50px #228DFF,
               0 0 75px #228DFF;
  }
}
@keyframes neon2 {
  from {
    text-shadow: 0 0 10px #e1e1e2,
               0 0 20px  #e1e1e2,
               0 0 30px  #e1e1e2,
               0 0 40px  #228DFF,
               0 0 70px  #228DFF,
               0 0 80px  #228DFF,
               0 0 100px #228DFF,
               0 0 150px #228DFF;
  }
  to {
    text-shadow: 0 0 5px #e1e1e2,
               0 0 10px #e1e1e2,
               0 0 15px #e1e1e2,
               0 0 20px #228DFF,
               0 0 35px #228DFF,
               0 0 40px #228DFF,
               0 0 50px #228DFF,
               0 0 75px #228DFF;
  }
}
@media screen and (max-width: 800px) {
    .roll-rooms{
      display: none !important;
    }
    .case__info{
      width: 105%;
    }
    .case{
      width: 50%;
    }
    .titile_box{
      padding: 0 !important;
    }
}
//标题傍边的两条线
.titile_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35%;
}
.titile_box_lint1{
  height: 2px;
  // background-image: linear-gradient(to right,rgb(83, 82, 82), #ffffff);
  background-image: linear-gradient(to right,rgba(0, 0, 0, 0.2) 0%,rgba(0, 0, 0, 0.2) 20%, rgba(255, 255, 255, 0.1) 50%,#FFFFFF 100%);
  flex-grow: 1;
}
.titile_box_lint2{
  height: 2px;
  // background: linear-gradient(to right, red , blue);
  // background-image: linear-gradient(to right, #ffffff,rgb(83, 82, 82));
  background-image: linear-gradient(to left,rgba(0, 0, 0, 0.2) 0%,rgba(0, 0, 0, 0.2) 20%, rgba(255, 255, 255, 0.1) 50%,#FFFFFF 100%);

  flex-grow: 1;
}
.allbox_title{
  margin: 40px;
}
</style>
